module.exports = __webpack_public_path__ + "static/Solution_Graphic-b73a5cd59671dd4a6e523e9ec9641bef.png";